import { useInfiniteQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planQueryKeys, plansApiTypeOptions } from './constants'

export const useGetPlansInfinityQuery = (
  id,
  type = plansApiTypeOptions.PROJECTS,
  search,
  sortBy = 'Title',
  typeFilter = null,
  size = 15,
  stateFilter = 'Active',
  sortDirection = 'ASC',
  options
) => {
  const handleQuery = async ({ pageParam }) => {
    const config = {
      method: 'get',
      params: {
        search,
        size,
        page: pageParam,
        stateFilter,
        sortBy,
        sortDirection,
        typeFilter
      }
    }
    const { data } = await api(`/api/plans-api/${type}/${id}/children`, config)

    return data
  }

  return useInfiniteQuery({
    queryKey: [
      planQueryKeys.GET_PLANS,
      id,
      type,
      search,
      size,
      stateFilter,
      sortBy,
      sortDirection,
      typeFilter
    ],
    queryFn: handleQuery,
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) => {
      if (lastPage.last === true) {
        return undefined
      }
      return lastPageParam + 1
    },
    enabled: !!id,
    ...options
  })
}
